// eslint-disable-next-line spaced-comment
export default ({ size, color = '#000' } = {}) => /*html*/`
<svg width="${ size }" height="${ size }" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.3431 0H0.657012C0.0740986 0 -0.220038 0.707273 0.192989 1.1203L5.25 6.17807V11.8125C5.25 12.0266 5.35448 12.2273 5.52991 12.3501L7.71741 13.8808C8.14898 14.1829 8.74999 13.8768 8.74999 13.3432V6.17807L13.8071 1.1203C14.2193 0.708094 13.9272 0 13.3431 0Z" fill="${ color }"/>
</svg>
`
